import { useExamContext } from "@features/exam/contexts/ExamContext";
import { useAppStore } from "@hooks/useAppStore";
import { useAppTheme } from "@memorang/ui/useAppTheme";
import { buildHomeHeaderIcon } from "./helpers";

export const useHomeHeaderIcon = () => {
	const headerIconMode = useAppStore((state) => state.homeView?.headerIconMode);
	const companyIcon = useAppStore((state) => state.app?.logo?.company);

	const theme = useAppTheme();
	const {
		currentExamContext: { examIcon },
	} = useExamContext();

	return buildHomeHeaderIcon({
		headerIconMode,
		examIcon,
		companyIcon,
		isDark: theme.dark,
	});
};
